import { render, staticRenderFns } from "./AddTicket.vue?vue&type=template&id=73dfe226&scoped=true&"
import script from "./AddTicket.vue?vue&type=script&lang=js&"
export * from "./AddTicket.vue?vue&type=script&lang=js&"
import style0 from "./AddTicket.vue?vue&type=style&index=0&id=73dfe226&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dfe226",
  null
  
)

export default component.exports